<template>
  <section>
    <div v-if="loading">

      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"></div>
        <div class="w-full sm:w-auto flex">
            <email-download-list-button class="mr-2" />
            <router-link to="/admin/traffic/emails-without-finish" class="button text-white bg-theme-1 shadow-md mr-2">Cortes sin finalizar</router-link>
            <a data-target="#email" data-toggle="modal" class="button text-white bg-theme-1 shadow-md mr-2">Crear Corte</a>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <div class="overflow-auto">
      <table class="table table-report -mt-2">
        <thead>
            <tr>
                <th class="whitespace-no-wrap">NOMBRE</th>
                <th class="text-center whitespace-no-wrap">PROYECTO</th>
                <th class="text-center whitespace-no-wrap">ESTADO</th>
                <th class="text-center whitespace-no-wrap">FECHA</th>
                <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
        </thead>
        <tbody>
          <tr class="intro-x" v-for="email in filteredTasks">
              <td>
                  <a href="#" class="font-medium whitespace-no-wrap">{{email.name | limit}} - {{email.number}}</a>
                  <div class="text-gray-600 text-xs whitespace-no-wrap">{{email.campaign_attribute.name}}</div>
                  <div class="text-gray-600 text-xs whitespace-no-wrap">{{email.slug}}</div>
              </td>
              <td>
                  <div class="text-center text-xs">{{email.campaign_attribute.project_name}}</div>
                  <div class="text-center text-xs">{{email.campaign_attribute.project_account_name}} {{email.campaign_attribute.project_account_country_prefix}}</div>
              </td>
              <td class="w-40">
                <div class="flex items-center justify-center">
                    <template v-for="user in users" >
                      <div class="w-10 h-10 image-fit zoom-in" v-if="email.created_by === user.id" :key="`user-created_by-${user.id}`">
                          <img :alt="email.user_created_name"
                              class="tooltip rounded-full tooltipstered"
                              :src="user.avatar ? user.avatar : `/static/images/profile.png`"
                              :title="email.user_created_name">
                      </div>
                    </template>
                    <template v-for="user in users">
                      <div class="w-10 h-10 image-fit zoom-in -ml-5" v-if="email.user_id === user.id" :key="`user-user_id-${user.id}`">
                        <img :alt="email.user_name"
                              class="tooltip rounded-full tooltipstered"
                              :src="user.avatar ? user.avatar : `/static/images/profile.png`"
                              :title="email.user_name">
                      </div>
                    </template>
                </div>
                <div class="flex items-center justify-center">{{email.state_name}}{{email.hours ? ` - ${email.hours} hs` : ''}}</div>
              </td>
              <td><button class="button button--sm w-24 text-white" v-bind:class="email.time">{{email.date}}</button></td>
              <td class="table-report__action w-56">
                  <div class="flex justify-center items-center">
                      <router-link :to="'/admin/traffic/email/'+email.id" class="cursor-pointer flex items-center mr-3">
                        <app-icon v-bind:name="'edit'" v-bind:classname="'w-4 h-4 mr-2'"></app-icon>
                      </router-link>
                  </div>
              </td>
          </tr>
        </tbody>
      </table>
      </div>
      <!-- END: List -->

    </div>

    <app-loading v-else />

    <!-- Modal -->
    <div class="modal" id="email">
        <div class="modal__content modal__content--sm">
          <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
            <h2 class="font-medium text-base mr-auto">
                Crear Corte
            </h2>
          </div>
          <form  @submit.prevent="createEmail" enctype="multipart/form-data">
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-12">
                <label>Nombre</label>
                <input type="text" class="input w-full border mt-2 flex-1" v-model="email.name" required>
            </div>
            <div class="col-span-12 sm:col-span-12">
                <label>Numero de pieza(s)</label>
                <select class="input w-full border mt-2 flex-1" v-model="email.number" required>
                  <option value="" disabled>Seleccione...</option>
                  <option v-for="num in nums" :value="num">
                    {{num}}
                  </option>
                </select>
            </div>
            <div class="col-span-12 sm:col-span-12">
                <label>Fecha de entrega</label>
                <input type="date" class="input w-full border mt-2 flex-1" v-model="email.date" required>
            </div>
            <div class="col-span-12 sm:col-span-12">
                <label>Proyecto</label>
                <select class="input w-full border mt-2 flex-1" v-model="email.project_id" required>
                  <option value="" disabled>Seleccione...</option>
                  <option v-for="project in projects" :value="project.id">
                    {{project.name}} - {{project.account.name}} {{project.account.country.prefix}}
                  </option>
                </select>
            </div>
            <div class="col-span-12 sm:col-span-12">
                <label>Campaña</label>
                <select class="input w-full border mt-2 flex-1" v-model="email.campaign_id" required>
                    <option value="" disabled>Seleccione...</option>
                    <option v-for="campaign in filteredCampaigns" :value="campaign.id">
                      {{campaign.name}}
                    </option>
                </select>
            </div>
            <div class="col-span-12 sm:col-span-12">
                <label>Url Archivo</label>
                <input type="text" class="input w-full border mt-2 flex-1" v-model="email.path" required>
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
              <button type="button" data-dismiss="modal" class="button w-20 border text-gray-700 mr-1">Cancelar</button>
              <button type="submit" class="button w-20 bg-theme-1 text-white" id="create">Crear</button>
          </div>
          </form>
        </div>
      </div>
      <!-- Modal End -->

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'
import EmailDownloadListButton from '@/components/admin/email/EmailDownloadListButton'

export default {
  name: 'AdminListEmail',
  data () {
    return {
      loading: false,
      email: this.defineEmail(),
      nums: [1,2,3,4,5,6,7,8,9,10]
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      emails: 'getEmails',
      campaigns: 'getCampaigns',
      projects: 'getProjects',
      users: 'getUsers',
    }),
    filteredCampaigns() {
      this.email.campaign_id = ""
      return this.campaigns.filter(v => {
        return v.project_id == this.email.project_id
      })
    },
    filteredTasks() {
      return this.emails.slice(0,500)
    }
  },
  mounted() {
    $('#email').on('hidden.bs.modal', () => { this.defineEmail() })
  },
  async beforeMount () {
    try {
      await this.getListEmailsMongo('email')
      this.getList('campaign')
      this.getList('project')
      this.getList('user')
      this.loading = true
    } catch (error) {} finally {
        this.loading = true
    }
  },
  methods: {
    defineEmail() {
      return {
        name: '',
        number: '',
        date: '',
        campaign_id: '',
        entity: 'email',
        path: '',
        project_id: '',
        created_by: ''
      }
    },
    createEmail () {
      var vm = this
      window.$('#create').button('loading')
      vm.email.created_by = this.user.id
      vm.store(vm.email).then(item => {
        window.$('#email').modal('hide')
        vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/emails')
      })
      .catch(error => {
        console.log('FAILURE!!');
      })
      .finally(() => {
        window.$('#create').button('reset')
        vm.loading = true
        this.defineEmail()
      });
    },
    ...mapActions([
      'getAll',
      'getListEmailsMongo',
      'store'
    ])
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
    EmailDownloadListButton
  },
}
</script>



// WEBPACK FOOTER //
// ListEmail.vue?0867b16e